var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable } from "mobx";
import { PatientConsentViewModel } from "./PatientConsentViewModel";
import { NOT_LOADED } from "../Infra/RemoteData";
import { getObservableT } from "../Infra/i18next";
const t = getObservableT("patients");
export class PatientConsentDeclinedViewModel extends PatientConsentViewModel {
    constructor() {
        super(...arguments);
        this.isCompleting = false;
    }
    get title() {
        return this.getCustomizedText("thankYouDeclinedTitle");
    }
    get supportingText() {
        if (this.isIAS) {
            return t("Your health records will not be accessed.");
        }
        return this.getCustomizedText("thankYouDeclinedText");
    }
    get confirmationAccessSettingsText() {
        return t("You can review and change access settings at any time on HealthEx.");
    }
    get isEmailContactPreference() {
        return this.preferredContactMethod === "EMAIL";
    }
    get organizationLogoUrl() {
        if (this.patientConsentUIManager.studyInfo !== NOT_LOADED && this.patientConsentUIManager.studyInfo !== null) {
            return this.patientConsentUIManager.studyInfo.addedByOrganization.logoUrl;
        }
        return null;
    }
    get buttonText() {
        return this.isAIFlow ? t("Go to {{ aiToolName }}", { aiToolName: this.aiToolName }) : t("Go to HealthEx");
    }
    async onComplete() {
        if (this.isPreview)
            return;
        if (this.isCompleting)
            return;
        this.isCompleting = true;
        if (this.isOAuthFlow) {
            await this.patientConsentUIManager.completeOAuthAfterPDDE();
        }
        else if (this.hasValidRedirectUriForAIFlow) {
            this.patientConsentUIManager.handleRedirectForAIFlow();
        }
        else {
            this.patientConsentUIManager.done();
        }
    }
}
__decorate([
    observable
], PatientConsentDeclinedViewModel.prototype, "isCompleting", void 0);
__decorate([
    computed
], PatientConsentDeclinedViewModel.prototype, "title", null);
__decorate([
    computed
], PatientConsentDeclinedViewModel.prototype, "supportingText", null);
__decorate([
    computed
], PatientConsentDeclinedViewModel.prototype, "confirmationAccessSettingsText", null);
__decorate([
    computed
], PatientConsentDeclinedViewModel.prototype, "isEmailContactPreference", null);
__decorate([
    computed
], PatientConsentDeclinedViewModel.prototype, "organizationLogoUrl", null);
__decorate([
    computed
], PatientConsentDeclinedViewModel.prototype, "buttonText", null);
